import React from "react";
import {
  DPTable,
  DPComponentLoader,
  DPEmptyTable,
  DPPermissionGate,
} from "Components/DP";
import { Header } from "Components/DP/DPTable/DPTable";
import { ApiResponseLogCategory, ApiResponseLog } from "generated/graphql";
import ApiResponseTableRow from "./ApiResponseTableRow/ApiResponseTableRow";
import useApiLogs from "./Hooks/useApiLogs";
import { Typography } from "@material-ui/core";

const apiLogHeaders: Header[] = [
  "Request Date/Time",
  "Status",
  "Response",
  "Request JSON",
];

type ApiResponseLogTableProps = {
  logCategory: ApiResponseLogCategory;
  title: string;
};
const ApiResponseLogTable = ({
  logCategory,
  title,
}: ApiResponseLogTableProps) => {
  const { page, rowsPerPage, data, handlePageChange, loading } = useApiLogs(
    logCategory
  );

  return (
    <DPPermissionGate permissionKeys={["canShowApiLogs"]}>
      <Typography variant={"h2"}>{title}</Typography>
      <DPTable
        count={data && data.apiResponseLogs.totalCount}
        headers={apiLogHeaders}
        {...data}
        page={page}
        rowsPerPage={rowsPerPage}
        colWidths={[30, 15, 35, 20]}
        onChangePage={handlePageChange}
      >
        {data && (
          <DPComponentLoader
            isLoading={loading}
            kind={"table"}
            awaitComponent={
              data.apiResponseLogs.items.length ? (
                <>
                  {data.apiResponseLogs.items.map(
                    (log: ApiResponseLog, idx: number) => (
                      <ApiResponseTableRow key={idx} {...log} />
                    )
                  )}
                </>
              ) : (
                <DPEmptyTable message={"API Logs will appear here"} />
              )
            }
          />
        )}
      </DPTable>
    </DPPermissionGate>
  );
};
export default ApiResponseLogTable;
